import { useState, type FormEvent } from 'react';

const FORM_ADDR = 'https://readdy.ai/api/form/da1avfgmlpfrg29fpf30';

export default function Subscribe() {
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = (formData.get('phone_alt') as string) || '';
    if (honeypot.trim() !== '') {
      setStatus('success');
      setMessage('订阅成功，感谢你的关注！');
      form.reset();
      return;
    }

    formData.delete('phone_alt');

    setStatus('loading');
    setMessage('');

    try {
      const res = await fetch(FORM_ADDR, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await res.text();
      let parsed: { code?: string; meta?: { message?: string; detail?: string }; message?: string } | null = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const serverMsg =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || '';

      if (
        res.ok &&
        parsed?.code === 'OK' &&
        !/spam|form data is spam/i.test(serverMsg)
      ) {
        setStatus('success');
        setMessage('订阅成功！每日更新的新图集将第一时间推送给你。');
        form.reset();
      } else {
        setStatus('error');
        setMessage(/spam|form data is spam/i.test(serverMsg) ? '提交过于频繁，请稍后再试。' : serverMsg || '订阅失败，请稍后再试。');
      }
    } catch {
      setStatus('error');
      setMessage('网络异常，订阅失败，请稍后再试。');
    }
  };

  return (
    <section id="subscribe" className="relative w-full scroll-mt-16 bg-background-100 py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="relative overflow-hidden rounded-lg bg-gradient-to-br from-primary-700 via-primary-600 to-accent-600 p-6 md:p-10">
          <div className="pointer-events-none absolute -right-10 -top-10 h-52 w-52 rounded-full bg-background-50/10 blur-2xl"></div>
          <div className="pointer-events-none absolute -bottom-12 left-1/4 h-44 w-44 rounded-full bg-accent-400/20 blur-2xl"></div>

          <div className="relative grid grid-cols-1 items-center gap-6 lg:grid-cols-2">
            <div>
              <h2 className="font-heading text-2xl font-bold text-background-50 md:text-3xl">订阅每日更新</h2>
              <p className="mt-3 max-w-md text-sm leading-relaxed text-background-50/90 md:text-base">
                留下邮箱，我们会在每天更新的同人图集发布后，第一时间把最新壁纸与画集推送到你的收件箱，不错过任何一张好图。
              </p>
            </div>

            <form data-readdy-form onSubmit={handleSubmit} className="flex flex-col gap-3">
              <div className="flex flex-col gap-2 sm:flex-row">
                <input
                  type="email"
                  name="email"
                  required
                  placeholder="请输入你的邮箱地址"
                  aria-label="邮箱地址"
                  className="h-12 w-full flex-1 rounded-md border border-background-50/30 bg-background-50/30 px-4 text-sm text-foreground-50 placeholder:text-foreground-200 focus:border-background-50 focus:outline-none focus:ring-2 focus:ring-background-50/40"
                />
                <button
                  type="submit"
                  disabled={status === 'loading'}
                  className="flex h-12 items-center justify-center whitespace-nowrap rounded-md bg-background-50 px-6 text-sm font-medium text-primary-700 transition-colors hover:bg-foreground-50 disabled:opacity-60"
                >
                  {status === 'loading' ? '提交中…' : '立即订阅'}
                </button>
              </div>

              <input type="text" name="phone_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly className="hp-field" />

              {status === 'success' && (
                <p className="flex items-center gap-1.5 text-sm text-background-50">
                  <i className="ri-checkbox-circle-fill"></i>
                  {message}
                </p>
              )}
              {status === 'error' && (
                <p className="flex items-center gap-1.5 text-sm text-foreground-100">
                  <i className="ri-error-warning-fill"></i>
                  {message}
                </p>
              )}
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}